<!-- CommercialService.vue -->
<!-- Presents a list of the commercial services available -->


<template>

  <!-- ********************************************** -->
  <!-- HEADER SECTION -->
  <!-- ********************************************** -->
  <v-row>
    <v-col>
      <v-row>
        <v-col :offset="$vuetify.breakpoint.xs ? 0 : 1" :cols="$vuetify.breakpoint.xs ? 12 : 10">

          <!-- Title -->
          <v-card-text primary-title class="text-title mb-0 px-0" :class="headerstore ? 'text-left' : 'text-center'">
            {{ i18n.t('chooseYourCommercialService') }}
          </v-card-text>

        </v-col>
      </v-row>


      <!-- "Back" Button -->
      <v-col class="pa-0 min-height-44 d-flex align-center" offset="1" cols="10">
        <BackBtn></BackBtn>
        <icon class="flex-grow-1" svg='step-marker-2' />
      </v-col>

      <!-- Some Alert -->
      <v-col class="pa-0 d-flex align-center" offset="1" cols="10">
        <AlertBox></AlertBox>
      </v-col>


      <!-- ********************************************** -->
      <!-- Not offered: replaces a list with only "Something Else?" -->
      <!-- ********************************************** -->
      <v-col v-if="onlySomethingElse" offset="1" cols="10" class="px-0 my-6 text-center">
        <div class="rounded-circle d-flex align-center justify-center mx-auto mb-4" style="width:56px;height:56px;background-color:rgba(31,82,143,0.1)">
          <v-icon color="#1F528F">{{ notOffered.icon }}</v-icon>
        </div>
        <div class="text-h6 font-weight-bold">{{ i18n.t(notOffered.title, { service: i18n.t(cardNames[form.serviceViewOptionId] || 'serviceView.thisService') }) }}</div>
        <p class="mt-2 mb-6">{{ i18n.t(notOffered.text) }}</p>
        <v-btn v-if="notOffered.button" block large depressed color="#1F528F" class="white--text rounded-lg" @click="switchCard()">
          {{ i18n.t(notOffered.button) }}
        </v-btn>
        <a class="d-inline-block mt-4 text-decoration-underline" style="color:#1F528F" @click="loading ? null : back()">{{ i18n.t("serviceView.changeAddress") }}</a>
      </v-col>

      <!-- ********************************************** -->
      <!-- Commercial Services Button -->
      <!-- ********************************************** -->

      <v-form v-else ref="wasteForm" v-model="formValid" lazy-validation>

        <!-- Carousel to display all services available -->
        <v-carousel height="100%" :hide-delimiters="true" hide-delimiter-background :show-arrows="false"
          :continuous="false">

          <v-col offset="1" cols="10" class="px-0">
            <v-carousel-item v-for="(slide, i) in slideshow" :key="i">
              <v-list>

                <v-list-item-group transition="scroll-x-transition" v-model="form.menuNavigationId"
                  @change="onChangeServiceList()">

                  <v-list-item v-slot="{ active }" class="blue-default-svg service-item rounded-lg my-4 py-4"
                    v-for="(item, i) in slide" :key="i" :value="item.name" height="85px" v-bind:disabled="loading"
                    v-ripple="loading ? false : true" active-class="blue-active-svg"
                    @click="form.categoryType = item.text; form.svgCategorySelected = item.icon;">

                    <!-- Icons -->
                    <div v-if="!active" class="icon-circle rounded-circle d-flex align-center justify-center flex-shrink-0 ml-4" style="width:40px;height:40px;min-width:40px;background-color:rgba(31,82,143,0.1)">
                      <icon contain :svg="item.icon" class="blue-svg" />
                    </div>
                    <div v-if="active" class="icon-circle rounded-circle d-flex align-center justify-center flex-shrink-0 ml-4" style="width:40px;height:40px;min-width:40px;background-color:rgba(255,255,255,0.2)">
                      <icon contain :svg="item.icon" class="white-svg" />
                    </div>


                    <!-- ********************************************** -->
                    <!-- Content in Commercial Button -->
                    <!-- ********************************************** -->
                    <v-list-item-content>

                      <!-- Text with traduction -->
                      <v-list-item-title class="text-h6 pl-6 pr-3" :class="active ? 'white--text' : 'black--text'">
                        <span>{{ item.displayText }}</span>
                         <!-- Icon -->
                         <v-icon v-if="goesStraightToStore(item)" right color="secondary">mdi-storefront-outline</v-icon></v-list-item-title>
                    </v-list-item-content>

                    <!-- Loading -->
                    <icon v-if="active" contain max-width="76px" max-height="71px" svg="checkmark"></icon>
                    <v-fade-transition>
                      <v-overlay v-if="form.menuNavigationId === item.name && form.categoryType === item.text && loadingWithService" absolute
                        color="#1F528F" opacity="0.9">
                        <div class="d-flex align-center px-4">
                          <v-progress-circular indeterminate size="24" width="3" class="mr-3"></v-progress-circular>
                          <span class="subtitle-1">{{ i18n.t("serviceView.redirectingToStore") }}</span>
                        </div>
                      </v-overlay>
                    </v-fade-transition>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-carousel-item>
          </v-col>
        </v-carousel>


        <!-- ********************************************** -->
        <!-- Message d'erreur -->
        <!-- ********************************************** -->

        <v-row v-if="!formValid && !this.form.menuNavigationId" class="my-3">
          <div class="v-messages error--text px-6 text-center" role="alert">
            <div class="subtitle-2">
              <v-icon class="error--text" left="left" dense="dense">mdi-alert-outline</v-icon> {{ i18n.t('missingField')
              }}
            </div>
          </div>
        </v-row>

      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { useUserStore } from "../../../../store/user";
import i18n from "@/i18n";
import icon from "../../utility/SvgLoader";
import { useIndexStore } from '../../../../store/index';
import { mapState, mapWritableState } from 'pinia';
import { mapActions } from 'pinia';
import BackBtn from "../../utility/backBtn.vue"
import AlertBox from "../../../sfc/Alert.vue"
import googleApi from "@/plugins/google"
import storefront from "@/plugins/storefront";
import salesforce from "@/plugins/salesforce";
import { useAxiosFormStore } from "@/store/axios";

export default {
  name: "CommercialService",
  components: { icon, BackBtn, AlertBox },
  data() {
    return {
      i18n: i18n,
      switched: false,
      districtHasServices: false,
      // Step 1 card names, used in the not offered notice title
      cardNames: { 2: "serviceView.wasteCollection", 3: "serviceView.constructionProjects", 5: "serviceView.jobSitesBusinesses" },
      slideshow: { // needed in the carousel
        serviceOptions: [
          {
            id: 1,
            name: "WasteRecyPickUp",
            apiName: "WasteAndRecycling",
            text: i18n.t('wasteAndRecyclingPickup', 'en'),
            textFr: i18n.t('wasteAndRecyclingPickup', 'fr'),
            displayText: i18n.t('wasteAndRecyclingPickup'),
            icon: "WasteRecyPickUp",
          },
          {
            id: 2,
            name: "WasteRecyPickUp",
            apiName: "WasteOnly",
            text: i18n.t("wasteOnly", "en"),
            textFr: i18n.t("wasteOnly", "fr"),
            displayText: i18n.t('wasteOnly'),
            icon: "WasteRecyPickUp",
          },
          {
            id: 3,
            name: "WasteRecyPickUp",
            apiName: "RecyclingOnly",
            text: i18n.t("recyclingOnly", "en"),
            textFr: i18n.t("recyclingOnly", "fr"),
            displayText: i18n.t('recyclingOnly'),
            icon: "WasteRecyPickUp",
          },
          {
            id: 4,
            name: "OrganicWaste",
            apiName: "Organics",
            text: i18n.t("organics", "en"),
            textFr: i18n.t("organics", "fr"),
            displayText: i18n.t('organics'),
            icon: "OrganicWaste",
          },
          {
            id: 5,
            name: "ShreddingView",
            apiName: "Shredding",
            text: i18n.t("shredding", "en"),
            textFr: i18n.t("shredding", "fr"),
            displayText: i18n.t('shredding'),
            icon: "Shredding",
          },
          {
            id: 6,
            name: "DumpsterRental",
            apiName: "DumpsterRental",
            text: i18n.t('dumpsterRentalConstructionBulkyPickup', 'en'),
            textFr: i18n.t('dumpsterRentalConstructionBulkyPickup', 'fr'),
            displayText: i18n.t('dumpsterRentalConstructionBulkyPickup'),
            icon: "DumpsterRental",
          },
          {
            id: 7,
            name: "MhoamView",
            apiName: "ApartmentsAndCondos",
            text: i18n.t('apartmentsCondosHOAs', 'en'),
            textFr: i18n.t('apartmentsCondosHOAs', 'fr'),
            displayText: i18n.t('apartmentsCondosHOAs'),
            icon: "MhoamView",
          },
          {
            id: 8,
            name: "CompIndustWaste",
            apiName: "CompactorsAndIndustrialWaste",
            text: i18n.t('compactorsAndIndustrialWaste', 'en'),
            textFr: i18n.t('compactorsAndIndustrialWaste', 'fr'),
            displayText: i18n.t('compactorsAndIndustrialWaste'),
            icon: "CompIndustWaste",
          },
          {
            id: 9,
            name: "MunicipalitiesView",
            apiName: "Municipalities",
            text: i18n.t('municipalities', 'en'),
            textFr: i18n.t('municipalities', 'fr'),
            displayText: i18n.t('municipalities'),
            icon: "Municipalities",
          },
          {
            id: 10,
            name: "PortableToilets",
            apiName: "PortableToilet",
            text: i18n.t('portableToilets', 'en'),
            textFr: i18n.t('portableToilets', 'fr'),
            displayText: i18n.t('portableToilets'),
            icon: "PortableToilets",
          },
          {
            id: 11,
            name: "SomethingElse",
            apiName: "SomethingElse",
            text: i18n.t('somethingElse', 'en'),
            textFr: i18n.t('somethingElse', 'fr'),
            displayText: i18n.t('somethingElse'),
            icon: "question",
          },
        ],
        defaultServiceOptions: [
          {
            id: 1,
            name: "WasteRecyPickUp",
            apiName: "WasteAndRecycling",
            text: i18n.t('wasteAndRecyclingPickup', 'en'),
            textFr: i18n.t('wasteAndRecyclingPickup', 'fr'),
            displayText: i18n.t('wasteAndRecyclingPickup'),
            icon: "WasteRecyPickUp",
          },
          {
            id: 2,
            name: "DumpsterRental",
            apiName: "DumpsterRental",
            text: i18n.t("dumpsterRentalConstructionBulkyPickup", "en"),
            textFr: i18n.t("dumpsterRentalConstructionBulkyPickup", "fr"),
            displayText: i18n.t('dumpsterRentalConstructionBulkyPickup'),
            icon: "DumpsterRental",
          },
          {
            id: 3,
            name: "MhoamView",
            apiName: "ApartmentsAndCondos",
            text: i18n.t("apartmentsCondosHOAs", "en"),
            textFr: i18n.t("apartmentsCondosHOAs", "fr"),
            displayText: i18n.t('apartmentsCondosHOAs'),
            icon: "MhoamView",
          },
          {
            id: 4,
            name: "CompIndustWaste",
            apiName: "CompactorsAndIndustrialWaste",
            text: i18n.t('compactorsAndIndustrialWaste', 'en'),
            textFr: i18n.t('compactorsAndIndustrialWaste', 'fr'),
            displayText: i18n.t('compactorsAndIndustrialWaste'),
            icon: "CompIndustWaste",
          },
          {
            id: 5,
            name: "MunicipalitiesView",
            apiName: "Municipalities",
            text: i18n.t("municipalities", "en"),
            textFr: i18n.t("municipalities", "fr"),
            displayText: i18n.t('municipalities'),
            icon: "Municipalities",
          },
          {
            id: 6,
            name: "SomethingElse",
            apiName: "SomethingElse",
            text: "Something Else?",
            displayText: i18n.t('somethingElse'),
            subtitle: "Send us a message",
            icon: "question",
          }

        ],
      },
    };
  },

  // * MOUNTED : Filtered service options based on the adresse
  mounted: function () {
    this.filterServiceOptions();
  },
  computed: {
    // Map state properties as readonly computed properties
    ...mapState(useIndexStore, [
      "showGetAQuote",
      "showGoToStore",
      "headerstore",
      "servicesofferedComm",
    ]),
    ...mapWritableState(useIndexStore, [
      'formValid',
      'loading',
      'loadingWithService',
      'apiResult',
      'apiResultOriginal',
    ]),
    ...mapWritableState(useUserStore, [
      "form",
    ]),
    // Only "Something Else?" is left for this card: show the not offered notice instead of a dead end
    onlySomethingElse() {
      return this.slideshow.serviceOptions.every(service => service.name === "SomethingElse");
    },
    // Icon and texts of the not offered notice. Construction can suggest Business Services (same COMMERCIAL lookup)
    notOffered() {
      if (this.form.serviceViewOptionId === 3 && this.districtHasServices && !this.switched) {
        return { icon: "mdi-office-building-outline", title: "serviceView.noConstructionTitle", text: "serviceView.noConstructionText", button: "serviceView.seeBusinessServices" };
      }
      return { icon: "mdi-information-outline", title: "serviceView.notOfferedTitle", text: "serviceView.notOfferedText" };
    },
  },
  methods: {
    ...mapActions(useIndexStore, [
      'back',
      'updateStages',
      'updateViewComponent',
      'getLeadTypeFromServiceType',
      'haveServicesForThisType',
      'refreshServicesForCategory',
    ]),
    // Switch from Construction to Business Services, same line so no new lookup
    switchCard() {
      this.form.serviceViewOptionId = 2;
      this.switched = true;
      this.slideshow = this.$options.data.call(this).slideshow;
      this.filterServiceOptions();
    },
    // District list (servicesofferedComm, RequestQuoteSetting) then the filter of the card picked on step 1
    filterServiceOptions() {
      if (this.servicesofferedComm) {
        this.slideshow = this.filterSlideshowByServices(this.slideshow, this.servicesofferedComm);
      }

      if (this.apiResultOriginal?.data?.RequestQuoteSetting?.Commercial) {
        this.updateServiceOptions('Commercial');
      } else if (!this.servicesofferedComm) {
        this.setDefaultServiceOptions();
      }
      this.districtHasServices = this.slideshow.serviceOptions.some(service => service.name !== "SomethingElse");

      if (this.form.serviceViewOptionId === 3) {
        const cardServiceOptions = this.slideshow.serviceOptions.filter(
          service => service.name === "DumpsterRental" || service.name === "SomethingElse"
        );
        // Keep the district list when the card filter leaves nothing
        if (cardServiceOptions.length) {
          this.slideshow.serviceOptions = cardServiceOptions;
        }
      }
      // Not offered notice shown: send No Service Stage to the lead, then put back the step for back()
      if (this.onlySomethingElse && this.form.leadExternalId) {
        const webLeadStep = this.form.webLeadStep;
        this.form.webLeadStep = "No Service Stage";
        salesforce.sendHttpRequestQuote('LeadInformation', useAxiosFormStore().getDataToAxios());
        this.form.webLeadStep = webLeadStep;
      }
    },
    // Store icon: a click on this service goes straight to the storefront (same branches as onChangeServiceList, no splitter or lead form)
    // Only known for the line already looked up, the other lines are fetched on click
    goesStraightToStore(item) {
      if (["Apartments, Condos & HOAs", "Compactors And Industrial Waste", "Municipalities"].includes(item.text) || this.form.serviceViewOptionId === 3) {
        return false;
      }
      const leadType = this.getLeadTypeFromServiceType(this.form.serviceType, item.text);
      return !!this.haveServicesForThisType(item.text, item.name)
        && ["Construction", "Commercial", "Portable Toilet"].includes(leadType)
        && !this.apiResult?.data?.RequestQuoteSetting?.Splitter?.SplitterToggle;
    },
    filterEnabledServices(settingType) {
      const settings = this.apiResultOriginal?.data?.RequestQuoteSetting?.[settingType] || {};
      return this.slideshow.serviceOptions.filter(service => settings[service.apiName]);
    },
    setDefaultServiceOptions() {
      this.slideshow.serviceOptions = this.slideshow.defaultServiceOptions;
    },
    filterSlideshowByServices(slideshow, services) {
      return Object.fromEntries(
        Object.entries(slideshow).map(([key, items]) => [
          key,
          items.filter(item => services.includes(item.name))
        ])
      );
    },
    updateServiceOptions(settingType) {
      let filteredServices = this.filterEnabledServices(settingType);

      // Ensure "Something Else" is always included
      const somethingElse = this.slideshow.serviceOptions.find(item => item.name === "SomethingElse");
      if (somethingElse && !filteredServices.some(item => item.name === "SomethingElse")) {
        filteredServices.push(somethingElse);
      }

      // Update service options or set to default if none available
      this.slideshow.serviceOptions = filteredServices.length ? filteredServices : this.slideshow.defaultServiceOptions;
    },
    async onChangeServiceList() {
      // Fetch the packages of this category's line of business (e.g. Portable Toilets) before choosing store vs lead
      const menuNavigationId = this.form.menuNavigationId;
      await this.refreshServicesForCategory();
      // Back was clicked during the call
      if (this.form.menuNavigationId !== menuNavigationId) return;

      const leadType = this.getLeadTypeFromServiceType(this.form.serviceType, this.form.categoryType).toLowerCase();
      const gTagParams = [leadType, 0, this.showGetAQuote ? "Display Splitter View" : "Display Lead Field", process.env.VUE_APP_GTAG_LEAD_CATEGORY, this.getLeadTypeFromServiceType(this.form.serviceType, this.form.categoryType), this.form.categoryType, this.apiResult.districtID];

      if (this.form.categoryType === "Apartments, Condos & HOAs" || this.form.categoryType === "Compactors And Industrial Waste" || this.form.categoryType === "Municipalities" || this.form.serviceViewOptionId === 3) {
        googleApi.gTagSendEvents(...gTagParams);
        this.updateStages("Redirect Stage");
      } else if (this.showGetAQuote && this.showGoToStore && !this.apiResult?.data?.RequestQuoteSetting?.Splitter?.SplitterToggle) {
        // When all three conditions are met, bypass splitter and go directly to store
        this.loadingWithService = true;
        this.form.webLeadStep = "Redirect Stage";
        storefront.sendInfoWithService();
      } else if (this.showGetAQuote && this.showGoToStore) {
        // Show splitter when both quote and store are available AND SplitterToggle is true
        googleApi.gTagSendEvents(...gTagParams);
        this.updateViewComponent('CommStorefront');
        this.form.menuOrder.push("CommStorefront");
        this.form.webLeadStep = "Redirect Stage";
      } else if (!this.showGetAQuote && this.showGoToStore) {
        // Always go to storefront when only store is available
        googleApi.gTagSendEvents(...gTagParams);
        this.updateViewComponent('CommStorefront');
        this.form.menuOrder.push("CommStorefront");
        this.form.webLeadStep = "Redirect Stage";
      } else {
        // Default case - go to lead form
        googleApi.gTagSendEvents(...gTagParams);
        this.updateStages("Redirect Stage");
      }
    },
  },
};
</script>

<style scoped>
.min-height-44 {
  min-height: 44px;
}
::v-deep .service-item {
  border: 1px solid rgba(31, 82, 143, 0.25) !important;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 8px -2px !important;
  transition: all 0.15s ease !important;
}
::v-deep .service-item:not(.v-list-item--active):hover {
  background-color: rgba(31, 82, 143, 0.05) !important;
  border-color: rgba(31, 82, 143, 0.60) !important;
}
::v-deep .service-item.v-list-item--active {
  background-color: #1F528F !important;
  border: 1px solid #1F528F !important;
}
::v-deep .service-item::before {
  border-radius: 8px !important;
}
::v-deep .service-item.v-list-item--active::before {
  opacity: 0 !important;
}
::v-deep .service-item .icon-circle svg {
  width: 22px !important;
  height: 22px !important;
}
</style>
